import {HttpRequest, HttpHandlerFn} from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const authInterceptor = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  return next(req);
};

//adding API_KEY to the request header for google maps api and cors   
export const addApiKeyInterceptor = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const apiKey = environment.GOOGLE_MAPS.API_KEY;
  const authReq = req.clone({
    headers: req.headers.set('X-Goog-Api-Key', `${apiKey}`),
  });
  return next(authReq);
};